import axios from 'axios'

const request2 = axios.create({
  baseURL: '',
  timeout: 20000000,
})

// 添加请求拦截器
request2.interceptors.request.use(config => {
  config.headers['Content-Type'] = "application/json";
  config.data = JSON.stringify(config.data);
  return config;
})

// 添加响应拦截器
request2.interceptors.response.use(
  (response) => {
    return response.data
  },
)

export default request2
